import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-background" data-testid="error-boundary-fallback">
          <div className="max-w-md bg-card border border-border rounded-2xl p-6 text-center space-y-3 shadow-sm">
            <div className="w-12 h-12 rounded-xl bg-red-50 text-red-600 flex items-center justify-center mx-auto text-2xl font-bold">!</div>
            <h2 className="font-display text-xl font-semibold">Something went wrong</h2>
            <p className="text-sm text-muted-foreground">
              The app ran into an unexpected error. Please refresh to continue. Your data is safe.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90"
              data-testid="error-boundary-refresh"
            >
              Refresh page
            </button>
            {this.state.error?.message && (
              <details className="text-left text-xs text-muted-foreground mt-2">
                <summary className="cursor-pointer">Technical details</summary>
                <pre className="mt-1 whitespace-pre-wrap break-words bg-muted/50 rounded p-2">{this.state.error.message}</pre>
              </details>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
